<template>
  <div class="content">
    <div class="set_wrap">
      <el-form ref="form" :model="formData" label-width="120px">
        <el-form-item label="文章标题">
          <el-input type="text" placeholder="请输入文章标题" maxlength="60" show-word-limit
                    v-model="formData.title"></el-input>
        </el-form-item>
        <!-- <el-form-item label="简介">
          <el-input type="textarea" placeholder="请输入简介" maxlength="2000" show-word-limit
                    v-model="formData.biref"></el-input>
        </el-form-item> -->
        <el-form-item label="所属栏目">
          <el-select v-model="formData.pro_id" placeholder="请选择栏目">
            <el-option
                    v-for="item in optionList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容">
          <quill-editor
                  class="quill-editor alleditorHeight"
                  v-model="formData.content"
                  ref="myQuillEditor"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorReady($event)"
          >
            <div id="toolbar" slot="toolbar"> <!-- Add a bold button -->
              <button class="ql-bold" title="加粗">Bold</button>
              <button class="ql-italic" title="斜体">Italic</button>
              <button class="ql-underline" title="下划线">underline</button>
              <button class="ql-strike" title="删除线">strike</button>
              <button class="ql-blockquote" title="引用"></button>
              <button class="ql-code-block" title="代码"></button>
              <button class="ql-header" value="1" title="标题1"></button>
              <button class="ql-header" value="2" title="标题2"></button> <!--Add list -->
              <button class="ql-list" value="ordered" title="有序列表"></button>
              <button class="ql-list" value="bullet" title="无序列表"></button> <!-- Add font size dropdown --> <select
                      class="ql-header" title="段落格式">
                <option selected>段落</option>
                <option value="1">标题1</option>
                <option value="2">标题2</option>
                <option value="3">标题3</option>
                <option value="4">标题4</option>
                <option value="5">标题5</option>
                <option value="6">标题6</option>
              </select>
              <select class="ql-size" title="字体大小">
                <option value="small">小</option>
                <option selected>常规</option>
                <option value="large">大</option>
                <option value="huge">特大</option>
              </select>
              <select class="ql-color" value="color" title="字体颜色"></select>
              <select class="ql-background" value="background" title="背景颜色"></select>
              <select class="ql-align" value="align" title="对齐"></select>
              <button class="ql-clean" title="还原"></button>
              <button class="ql-image" title="插入图片"></button>
              <button class="ql-video" title="插入视频"></button>
              <button class="ql-undo" title="撤销" @click="undo"></button>
              <button class="ql-redo" title="重做" @click="redo"></button>
            </div>
          </quill-editor>
        </el-form-item>
        <el-form-item label="插入商品">
          <el-button size="small" @click="onInsertCont(2)">选择商品</el-button>
          <span class="noticeP pl10">最多选择6件商品</span>
          <div>
            <el-tag type="info" v-for="item in formData.goods_arr" :key="item.id">{{item.goods_name}}</el-tag>
          </div>
        </el-form-item>
        <el-form-item label="插入表单">
          <el-button size="small" @click="onInsertCont(1)">选择表单</el-button>
           <span class="noticeP pl10">最多选择6个表单</span>
          <div>
            <el-tag type="info" v-for="item in formData.form_arr" :key="item.id">{{item.title}}</el-tag>
          </div>           
        </el-form-item>
        <el-form-item label="封面图片">
          <uploadImg @getChildValue="getChildValue" imgNumber="10" page="momentsEdit"
                     :picSrc="formData.pic"></uploadImg>
        </el-form-item>
        <el-form-item>
          <!--发布过的-->
          <div v-if="pageTypes=='add'">
            <el-button @click="onSubmit(0)" size="small">仅保存</el-button>
            <el-button type="primary" @click="onSubmit(1)" size="small">发布</el-button>
          </div>
          <div v-else>
            <div v-if="programaType==1">
              <el-button @click="priveBox" size="small">预览</el-button>
              <el-button type="primary" @click="onSubmit(0)" size="small">保存并取消发布</el-button>
              <el-button type="primary" @click="onSubmit(1)" size="small">发布</el-button>
            </div>
            <!--草稿箱-->
            <div v-if="programaType==2">
              <el-button type="primary" @click="priveBox" size="small">预览</el-button>
              <el-button @click="onSubmit(0)" size="small">仅保存</el-button>
              <el-button type="primary" @click="onSubmit(1)" size="small">发布</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
            title="预览"
            :visible.sync="priveBoxVisible"
            width="375px"
            :before-close="handleClose">
      <div v-html="formData.content" class="priveBoxbody"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="priveBoxVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <momentsEditDialog :visible.sync="dialogTableVisible" :page="pageDialog" :type="tableType" :property="tableData" :formdata="tableType==2?goodObj:formObj"
      @loadMoreGoodsOrForm="loadMoreGoodsOrForm" @updatePageInfo="updatePageInfo"></momentsEditDialog>        

  </div>
</template>
<script>
  import "quill/dist/quill.core.css";
  import "quill/dist/quill.snow.css";
  import "quill/dist/quill.bubble.css";
  import uploadImg from "@/components/dialog/uploadImg.vue";
  import momentsEditDialog from "@/components/dialog/momentsEditDialog.vue";
  import Quill from 'quill' //引入编辑器
  // import {ImageDrop} from 'quill-image-drop-module';
  import {quillEditor} from "vue-quill-editor";
  import { handlers, pasteImage } from "@/assets/js/quill-config";
  import Video from "@/assets/js/quill-video";
  import { pagination } from "@/util/util.js";
  import api from '@/api.js'
  Quill.register(Video, true);

  export default {
    name: "publishArticle",
    props: ["optionList", 'formData', 'pageType', 'programaType'],
    components: {
      quillEditor,
      uploadImg,
      momentsEditDialog
    },
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill;
      }
    },
    data() {
      return {
        uploadImg: api.uploadTokenImg,
        data_: {token: sessionStorage.getItem("token")},
        priveBoxVisible: false,
        form: {},
        editorOption: {
          placeholder: "请输入内容",
          theme: "snow", // or 'bubble'
          history: {
            delay: 2000,
            maxStack: 50,
            userOnly: true
          },
          modules: {
            // imageDrop: true, // 图片推拽上传
            toolbar: {
              container: '#toolbar',
              handlers
            }
          },
          theme: 'snow'
        },
        pageTypes: this.pageType,
        changeText:[],
        dialogTableVisible: false,
        pageDialog: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        }, 
        tableType: 0,
        tableData: [],
        goodObj: {
          check_type: 1,    // 筛选类型(0全部、1已上架、2已售罄、3未上架)
          goods_type: 0,    // 商品类型(0全部、1实体商品-仅线上展示、2实体商品-支持线上支付、3虚拟商品
          name: "",         // 商品名称
          cat_id: ""        // 分类id
        },
        formObj: {
          title: "",        // 表单名称
          status: 1         // 查看状态(0全部、1已启用、2未启用)
        }
      };
    },
    created() {
      this.form = this.formData
    },
    methods: {
      undo() {
        this.$refs.myQuillEditor.quill.history.undo();
      },
      redo(){
        this.$refs.myQuillEditor.quill.history.redo();
      },
      onSubmit(type) {
        // is_sub 	varchar 	必填 	- 	- 	是否发布(0仅保存、1已发布)
        this.form.is_sub = type
        this.$emit('saveFrom', this.form);
      },
      handleAvatarSuccess(res, file, fileList) {
        if (res.code === 0) {
          this.form.pic = [res.path]
        }
        this.loadingStatus.close();
      },
      handleClose() {},
      beforeAvatarUpload(file) {
        // const isJPG = file.type === "image/jpeg";
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 10MB!");
        }
        this.loadingStatus = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass: 'fontColor'
        });
        return isLt2M;
      },
      onEditorBlur(quill) {
        // console.log("editor blur!", quill);
      },
      onEditorFocus(quill) {
        // console.log("editor focus!", quill);
      },
      onEditorReady(quill) {
        // console.log("editor ready!", quill);
      },
      priveBox() {
        this.priveBoxVisible = true
      },
      getChildValue(option) {
        this.form.pic = [option]
      },
      onInsertCont(type) {
        this.pageDialog.pageindex = 1;
        this.tableType = type;
        if (type == 2) {
          this.goodObj.check_type = 1;
          this.goodObj.goods_type = 0;
          this.goodObj.name = '';
          this.goodObj.cat_id = '';
        }
        if (type == 1) {
          this.formObj.title = '';
          this.formObj.status = 1;
        }
        this.initGoodsOrForm(0, type);
      },
      // 关联商品、表单
      initGoodsOrForm(num, type) {
        let tableObj;
        if (type == 2) {  // type 2-选择已上架商品 1-选择表单 
          tableObj = this.goodObj;
        } else {
          tableObj = this.formObj;
        }
        tableObj.page = this.pageDialog.pageindex;
        this.axios   
          .post(type == 2 ? api.goods_index : api.companyadmin_form_list, tableObj)
          .then(response => {
            if (response.data.code == 0) {
              this.tableData = response.data.list;
              this.pageDialog.total = response.data.all_page;
              if (num == 0) {
                this.dialogTableVisible = true;
              }
            }
          })
          .catch(() => {});      
      },  
      // 加载更多数据
      loadMoreGoodsOrForm(e) {
        this.pageDialog.pageindex = e.pageindex;
        if (e.type == 2) {
          this.goodObj = e.obj;
        } else {
          this.formObj = e.obj;
        }
        this.initGoodsOrForm(1, e.type);
      },
      // 更新当前页面数据
      updatePageInfo(e) {  
        if (e.type == 2) {
          this.form.goods_arr = e.obj;
          this.$set(this.form, 'goods_arr', this.form.goods_arr);
        } else {
          this.form.form_arr = e.obj;
          this.$set(this.form, 'form_arr', this.form.form_arr);
        }  
      }
    },
    mounted() {
      this.$emit('update:formData', this.form)
      let revoke=document.querySelector('.quill-editor .ql-undo') //获取元素
      let redo=document.querySelector('.quill-editor .ql-redo') //获取元素
      let Front=document.createElement('i')  //创建元素
      let Frontredo=document.createElement('i')  //创建元素
      Front.className="iconfont iconchexiao" //新增class属性
      Frontredo.className="iconfont iconredo" //新增class属性
      revoke.appendChild(Front) //追加到元素中
      redo.appendChild(Frontredo) //追加到元素中
      pasteImage(this.editor)
    },
    watch: {
      // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
      // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
      formData: {
        immediate: true,
        handler(val) {
          this.form = val
        }
      }
    }
  };
</script>
